module.exports = __webpack_public_path__ + "static/media/brush.575b5bba.svg";